export interface AppUrl {
  label: string;
  host: string;
  href: string;
  recordId?: string;
}

/** Public URLs of an app: the main subdomain plus one per additional DNS record. */
export function appUrls(app: { full_subdomain?: string; additional_dns_records?: Record<string, string> }): AppUrl[] {
  const sub = app.full_subdomain;
  if (typeof sub !== 'string' || sub === '') return [];

  const urls: AppUrl[] = [{ label: 'Main', host: sub, href: `https://${sub}` }];

  const records = app.additional_dns_records;
  if (records === null || typeof records !== 'object') return urls;

  const dot = sub.indexOf('.');
  const first = dot === -1 ? sub : sub.slice(0, dot);
  const rest = dot === -1 ? '' : sub.slice(dot + 1);

  for (const prefix of Object.keys(records).sort()) {
    if (prefix === '') continue;
    const host = rest ? `${prefix}-${first}.${rest}` : `${prefix}-${first}`;
    urls.push({ label: `Port ${prefix}`, host, href: `https://${host}`, recordId: records[prefix] });
  }
  return urls;
}
